import React, { useCallback, useEffect, useMemo, useState } from 'react'
import useParams from 'core/hooks/useParams'
import FormFieldSection from 'core/components/validatedForm/FormFieldSection'
import useUpdateAction from 'core/hooks/useUpdateAction'
import ModalForm from 'core/elements/modal/ModalForm'
import TextField from 'core/components/validatedForm/TextField'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import { listUsers } from 'account/components/userManagement/users/new-actions'
import { usersSelector } from 'account/components/userManagement/users/selectors'
import useListAction from 'core/hooks/useListAction'
import { useSelector } from 'react-redux'
import { listDomains, updateDomain } from './actions'
import ToggleSwitchField from 'core/components/validatedForm/ToggleSwitchField'
import Text from 'core/elements/Text'

const useStyles = makeStyles<Theme>((theme) => ({
  toggleSwitch: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  switchTooltip: {
    padding: theme.spacing(1),
    color: theme.palette.common.white,
  },
}))

interface Props {
  rows: any[]
  onClose: () => void
}

export default function EditDomainModal({ rows: [domain], onClose }: Props) {
  const classes = useStyles()
  const defaultParams = {
    name: '',
    description: '',
    roleAssignments: {},
    enabled: true,
  }
  const [roleAssignments, setRoleAssignments] = useState([])
  const [loadingRoleAssignments, setLoadingRoleAssignments] = useState(true)
  const [dataLoaded, setDataLoaded] = useState(false)
  const { params, getParamsUpdater, setParams, updateParams } = useParams(defaultParams)

  const { loading: loadingUsers } = useListAction(listUsers)
  const users = useSelector(usersSelector)
  const { reload: reloadDomains } = useListAction(listDomains)
  const { update, updating, error, reset } = useUpdateAction(updateDomain)

  //   useEffect(() => {
  //     const makeCalls = async () => {
  //       const response = await getTenantRoleAssignments({ tenantId: tenant.id })
  //       setRoleAssignments(response)
  //       setLoadingRoleAssignments(false)
  //     }
  //     makeCalls()
  //   }, [])

  useEffect(() => {
    // if (loadingRoleAssignments) {
    //   return
    // }
    const initialParams = {
      id: domain.id,
      name: domain.name,
      description: domain.description || '',
      enabled: domain.enabled,
      //   roleAssignments: roleAssignments.reduce(
      //     (acc, roleAssignment) => ({
      //       ...acc,
      //       [pathStr('user.id', roleAssignment)]: pathStr('role.id', roleAssignment),
      //     }),
      //     {},
      //   ),
    }
    updateParams(initialParams)
    setDataLoaded(true)
  }, [domain])

  const initialContext = useMemo(() => {
    return {
      id: domain.id,
      name: domain.name,
      description: domain.description || '',
      enabled: domain.enabled,
      //   roleAssignments: roleAssignments.reduce(
      //     (acc, roleAssignment) => ({
      //       ...acc,
      //       [pathStr('user.id', roleAssignment)]: pathStr('role.id', roleAssignment),
      //     }),
      //     {},
      //   ),
    }
  }, [domain, roleAssignments, loadingRoleAssignments])

  const loadingSomething = loadingUsers || !dataLoaded

  const submitForm = useCallback(async () => {
    const body = {
      domain: {
        id: domain?.id,
        name: params.name,
        description: params.description,
        enabled: params.enabled,
        //   roleAssignments: params.roleAssignments,
      },
    }
    const { success } = await update({ id: domain?.id, body })
    if (success) {
      reloadDomains(true, true)
      handleClose()
    }
  }, [domain?.id, params])

  const handleClose = () => {
    setParams(defaultParams)
    setDataLoaded(false)
    setLoadingRoleAssignments(true)
    setRoleAssignments([])
    reset()
    onClose()
  }

  return (
    <ModalForm
      title={`Edit Domain`}
      onSubmit={submitForm}
      onClose={handleClose}
      loading={loadingSomething}
      submitting={updating}
      error={error}
      initialValues={initialContext}
      submitTitle={`Update Domain`}
      open
    >
      <>
        <FormFieldSection title="Domain Settings">
          <TextField
            id="name"
            label="Name"
            onChange={getParamsUpdater('name')}
            value={params.name}
            disabled={domain?.name === 'service'}
            required
          />
          <TextField
            id="description"
            label="Description"
            onChange={getParamsUpdater('description')}
            value={params.description}
            disabled={domain?.name === 'service'}
          />
          <div className={classes.toggleSwitch}>
            <ToggleSwitchField
              id="enabled"
              label="Enable Domain"
              value={params.enabled}
              onChange={(value) => getParamsUpdater('enabled')(value)}
              customTooltipInfoBody={
                <Text variant="body2" className={classes.switchTooltip}>
                  Enabling the domain will make it available for users to assign roles to users and
                  groups.
                </Text>
              }
            />
          </div>
          {/* <Progress
            renderContentOnMount={!loadingSomething}
            loading={loadingSomething}
            message={'Loading Users...'}
          >
            <UserRolesTableField
              // validations={userRolesValidations}
              id="roleAssignments"
              users={users}
              onChange={getParamsUpdater('roleAssignments')}
              value={params.roleAssignments}
            />
          </Progress> */}
        </FormFieldSection>
      </>
    </ModalForm>
  )
}
